import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { CustomerActionsComponent }        from './customer.actions.component';
import { CustomerBilledComponent }         from './customer-billed.component';
import { CustomerEventsComponent }         from './customer-events.component';
import { CustomerInspectionsComponent }    from './customer-inspections.component';
import { CustomerInvoicesComponent }       from './customer-invoices.component';
import { CustomerPaymentsListComponent }   from './customer-payments-list.component';
import { CustomerPaymentsModule }          from './customer-payments/customer-payments.module';
import { CustomerQuotesComponent }         from './customer-quotes.component';
import { CustomerVehiclesComponent }       from './customer-vehicles.component';
import { CustomersStates }                 from './customers.states';
import { CustomerPaymentActionsComponent } from './customer-payments/customer-payment.actions.component';
import { CustomerVehicleActionsComponent } from './customer.vehicle.actions.component';
import { SharedModule }                    from '../../app-lite/shared/shared.module';
import { TableModule }                     from '../../app-lite/table/table.module';

@NgModule({
  declarations: [
    CustomerActionsComponent,
    CustomerBilledComponent,
    CustomerEventsComponent,
    CustomerInspectionsComponent,
    CustomerInvoicesComponent,
    CustomerPaymentActionsComponent,
    CustomerPaymentsListComponent,
    CustomerQuotesComponent,
    CustomerVehiclesComponent,
    CustomerVehicleActionsComponent
  ],
  entryComponents: [
    CustomerActionsComponent,
    CustomerPaymentActionsComponent,
    CustomerVehicleActionsComponent
  ],
  exports: [
    CustomerBilledComponent,
    CustomerEventsComponent,
    CustomerInspectionsComponent,
    CustomerInvoicesComponent,
    CustomerPaymentsListComponent,
    CustomerQuotesComponent,
    CustomerVehiclesComponent
  ],
  imports: [
    CustomerPaymentsModule,
    SharedModule,
    TableModule,
    UIRouterModule.forChild({ states: CustomersStates })
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class CustomersModule {}